import API, { baseURL } from './api';
import { getSucursalInfo } from './auth';

// Client for sge_infantil_core's routes/paymentTypes.js (mounted at /api/paymentTypes).
// Tipos de Pagamento (Numerário, POS, Transferência Bancária, Mpesa, eMola,
// mKesh, Cheque, Depósito, ...) guardados por sucursal em SGE_PAYMENT_TYPES,
// em vez do array fixo PAYMENT_METHODS que existia em utils/paymentHelpers.js.
// Semeados por omissão em todas as sucursais activas por
// sge_infantil_core/scripts/seed-payment-types.js.
export async function listPaymentTypes(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/paymentTypes/${id}`);
}

export async function createPaymentType(name, sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/paymentTypes`, { name, sucursalId: id });
}
